const getComponentLocation = ref => {
  if (ref) {
    return ref.getBoundingClientRect()
  }
}

export default getComponentLocation
